import { combineReducers } from "redux";

import { templatesApiReducers as templates } from "./templates";
import { searchApiReducers as search } from "./search";

export default combineReducers({
  templates,
  search
});
